import { render, staticRenderFns } from "./UserImpersonate.vue?vue&type=template&id=1316416d"
import script from "./UserImpersonate.vue?vue&type=script&lang=js"
export * from "./UserImpersonate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports